import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../irtiza-dynamic-input/irtiza-dynamic-main-inputs';

const FullYarnCountInfoAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
  
    FullYarnCountID:{name: 'FullYarnCountID',   value: props.FullYarnCountID || '' ,enabled:false},

    YarnCount:{
      name:{id:'YarnCountID',value:'YarnCount'},
      caption: 'Select Yarn Count',
      value: {id: props.YarnCountID || undefined ,value:props.YarnCount || ''},
      dataSource: {type:'Route',route:'YarnCountInfo'},
        },

    YarnThread:{name: 'YarnThread',   value: props.YarnThread || 1 , decimal : 0 },

    YarnQuality:{
      name:{id:'YarnQualityID',value:'YarnQuality'},
      caption: 'Select Yarn Quality',
      value: {id: props.YarnQualityID || undefined ,value:props.YarnQuality || ''},
      dataSource: {type:'Route',route:'YarnQualityInfo'},
        },

    YarnType:{
      name:{id:'YarnTypeID',value:'YarnType'},
      caption: 'Select Yarn Type',
      value: {id: props.YarnTypeID || undefined ,value:props.YarnType || ''},
      dataSource: {type:'Route',route:'YarnTypeInfo'},
        },


        });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.FullYarnCountID, setInputProps },ColumnSize:0},
    {Input: DropdownComponent,Props: {...inputProps.YarnCount, setInputProps },ColumnSize:6},
    {Input: NumberComponent,Props: {...inputProps.YarnThread,setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.YarnQuality, setInputProps },ColumnSize:6},
    {Input: DropdownComponent,Props: {...inputProps.YarnType, setInputProps },ColumnSize:6},
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Full Yarn Count ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default FullYarnCountInfoAdd;
